module.exports = __webpack_public_path__ + "sm.0496dadce7e3386835d8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sm.svg
// module chunks = styles